import environment from '@/modules/cart/environments/environment';
import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';

const { CART_URL } = environment;

const MERGE_CART_URL = `${CART_URL}/merge-cart`;

export async function mergeGuestCart(
  anonymousId: string
): Promise<{ data: HttpCartDto }> {
  const res = await httpClient.post(MERGE_CART_URL, {
    anonymousId
  });

  return { data: res.data };
}
